import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RegistrationApprovalPage from '../onboarding/RegistrationApprovalPage';
import AssignGridPage from '../assign-grid/AssignGridPage';
import HomePage from '../home/HomePage';
import KYCVerificationPage from '../onboarding/KYCVerificationPage';
import ViewTaskPage from '../task-assigned/ViewTaskPage';
import CreateTaskPage from '../task-assigned/CreateTaskPage';
import TrackLocation from '../track-location/TrackLocation';
import SetTargetsPage from '../targets/SetTargetsPage';
import CreateLeadPage from '../leads/CreateLeadPage';
import ViewLeadsPage from '../leads/ViewLeadsPage';
import SettingPage from '../setting/SettingPage';
import IceOpsPage from '../IFrames/IceOpsPage';
import ChmOpsPage from '../IFrames/ChmOpsPage';
import ViewAttendeesPage from '../attendance/ViewAttendeesPage';
import TrackCompliantListPage from '../compliant/TrackCompliantListPage';
import CreateMarketingActivityPage from '../create-activity/CreateMarketingActivityPage';
import ApplyReimbursementPage from '../reimbursement/ApplyReimbursementPage';
import ApproveReimbursementPage from '../reimbursement/ApproveReimbursementPage';
import ViewMarketingActivityPage from '../create-activity/ViewMarketingActivityPage';
import ReportsPage from '../IFrames/ReportsPage';
import ViewRemuneration from '../remuneration/ViewRemuneration';
import WelcomeVideos from '../admin-settings/welcome-videos/WelcomeVideosPage';
import BannerPage from '../admin-settings/banner/BannerPage';
import LatestUpdatesPage from '../admin-settings/latest-updates/LatestUpdatesPage';
import GalleryPage from '../admin-settings/gallery/galleryPage';
import ApproveLeave from '../attendance/ApproveLeave';
import LeaveHistory from '../attendance/LeaveHistory';
import KnowledgeCenterPage from '../admin-settings/knowledgeCenter/KnowlegdeCenterPage';
import TopPerformersPage from '../IFrames/TopPerformers';
import RoleManagementPage from '../admin-settings/employee/RoleManagementPage';
import EmployeeInformationPage from '../admin-settings/employee/EmployeeInformationPage';
import EmployeeDataPage from '../admin-settings/employee/EmployeeDataPage';
import DashboardPage from '../IFrames/DashboardPage';
import ClaimSearchPage from '../claim-search/ClaimSearchPage';

export const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/assign-grid" element={<AssignGridPage />} />
      <Route
        path="/registration-approval"
        element={<RegistrationApprovalPage />}
      />
      <Route path="/kyc-verification" element={<KYCVerificationPage />} />
      <Route path="/create-task" element={<CreateTaskPage />} />
      <Route path="/view-task" element={<ViewTaskPage />} />
      <Route path="/track-location" element={<TrackLocation />} />
      <Route path="/set-targets" element={<SetTargetsPage />} />
      <Route path="/create-lead" element={<CreateLeadPage />} />
      <Route path="/view-lead" element={<ViewLeadsPage />} />
      <Route path="/view-attendees" element={<ViewAttendeesPage />} />
      <Route path="/track-complaint" element={<TrackCompliantListPage />} />
      <Route
        path="/create-activity"
        element={<CreateMarketingActivityPage />}
      />
      <Route path="/view-activity" element={<ViewMarketingActivityPage />} />
      <Route path="/approve-leaves" element={<ApproveLeave />} />
      <Route path="/leave-history" element={<LeaveHistory />} />
      <Route path="/apply-reimbursement" element={<ApplyReimbursementPage />} />
      <Route path="/claim-search" element={<ClaimSearchPage />} />
      <Route
        path="/approve-reimbursement"
        element={<ApproveReimbursementPage />}
      />
      <Route path="/claim-search" element={<ClaimSearchPage />} />
      <Route path="/top-performers" element={<TopPerformersPage />} />
      <Route path="/setting" element={<SettingPage />} />
      <Route path="/ice-ops" element={<IceOpsPage />} />
      <Route path="/chm-ops" element={<ChmOpsPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route
        path="/employee-information"
        element={<EmployeeInformationPage />}
      />
      <Route path="/employee" element={<EmployeeDataPage />} />
      <Route path="/view-remuneration" element={<ViewRemuneration />} />
      <Route path="/welcome-videos" element={<WelcomeVideos />} />
      <Route path="/banner" element={<BannerPage />} />
      <Route path="/latest-updates" element={<LatestUpdatesPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/knowledge-center" element={<KnowledgeCenterPage />} />
      <Route path="/role-management" element={<RoleManagementPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
